import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import ChartSelectQuestion from "../../../../question/ChartSelectQuestion";
import InfoCard from "../../../DynamicStep/components/InfoCard";

const CustodianStep = props => {
  const {
    onAnswerChange,
    questions: [
      depotsQuestion
    ],
    dataService
  } = props;

  const [renderer, forceRender] = React.useState(0);

  React.useEffect(() => {
    dataService.initCustodianChoices(depotsQuestion);

    // workaround to force component re-render with new options
    forceRender((prev) => prev + 1)
  }, []);

  if(renderer !== 0 && _.isEmpty(depotsQuestion.config.choices)){
    return (
      <InfoCard isNewDesign cardType={'warning'}>
        Bitte wählen Sie zuerst eine Anlageart aus. Danach zeigen wir Ihnen die verfügbaren Depotbanken an.
      </InfoCard>
    )
  }

  return (
    <Grid container spacing={2}>
      <ChartSelectQuestion
        question={depotsQuestion}
        dataService={dataService}
        onAnswerChange={onAnswerChange}
      />
    </Grid>
  );
};

export default CustodianStep;
